import { render, staticRenderFns } from "./PromptImageForm.vue?vue&type=template&id=19239db5&scoped=true&"
import script from "./PromptImageForm.vue?vue&type=script&lang=js&"
export * from "./PromptImageForm.vue?vue&type=script&lang=js&"
import style0 from "./PromptImageForm.vue?vue&type=style&index=0&id=19239db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19239db5",
  null
  
)

export default component.exports